import type { RouteRecordRaw } from 'vue-router'

const partnersRoutes: RouteRecordRaw[] = [
  {
    path: 'partners/:partnerName(uswitch)/checkout',
    name: 'checkout_partners',
    component: () =>
      import('~/scopes/checkout/flows/partners/PartnerCheckoutPage.vue'),
    meta: {
      owners: ['bot-squad-partnerships-front'],
      layout: false,
    },
  },
]

export default partnersRoutes
